export const SET_OUTLET_META = 'SET_OUTLET_META'
export const SET_MAPPINGS = 'SET_MAPPINGS'
export const SET_MAPPINGS_LOADING = 'SET_MAPPINGS_LOADING'
export const ADD_MAPPING = 'ADD_MAPPING'
export const DELETE_MAPPING = 'DELETE_MAPPING'
export const SET_PATHS = 'ADD_PATHS'
export const SET_PATHS_LOADING = 'SET_PATHS_LOADING'
export const DEFAULT_STATE = 'SET_DEFAULT_STATE'
